var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMobileEventPlace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5,
  height: 8,
  viewBox: "0 0 5 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.5 0C3.88 0 5 1.167 5 2.607c0 .217-.134 1-.336 1.384-.482.914-1.346 1.754-1.678 2.558-.45 1.088.115.945-.486.945-.6 0-.016.106-.464-.958C1.698 5.73.838 4.953.35 4.027.14 3.63 0 2.832 0 2.607 0 1.167 1.12 0 2.5 0m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
})));
export default SvgGoogleMobileEventPlace;